import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/**
 * Renders one menu item.
 */
export const MenuItem = ({ children }: Props) => {
  return <div className="item">{children}</div>;
};
